module.exports = __webpack_public_path__ + "img/usedIcon.1e89cfca.png";